/** Solicitudes de reapertura para una respuesta complementaria: las de un caso y sus acciones (pedir, decidir, cancelar). */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { CaseReopenRequestsView, CreateReopenRequestInput, DecideReopenRequestInput, ReopenRequestView } from '@pqrs/contracts';
import { apiGet, apiPost } from '@/api/client';
import { caseKeys } from '@/features/cases/api';

export const reopenRequestKeys = { case: (caseId: string) => ['reopen-requests', 'case', caseId] as const };

export const useCaseReopenRequests = (caseId: string, enabled = true) => useQuery({ queryKey: reopenRequestKeys.case(caseId), queryFn: () => apiGet<CaseReopenRequestsView>(`/reopen-requests/cases/${caseId}`), enabled });

/** Aprobarla reabre el expediente: cambian el estado, el índice y las tareas; se recarga todo el caso y las bandejas. */
function useInvalidateReopen() {
  const qc = useQueryClient();
  return (caseId: string) => {
    void qc.invalidateQueries({ queryKey: reopenRequestKeys.case(caseId) });
    void qc.invalidateQueries({ queryKey: caseKeys.all });
    void qc.invalidateQueries({ queryKey: caseKeys.index(caseId) });
    void qc.invalidateQueries({ queryKey: ['tasks'] });
  };
}

export function useCreateReopenRequest(caseId: string) {
  const inv = useInvalidateReopen();
  return useMutation({ mutationFn: (input: CreateReopenRequestInput) => apiPost<ReopenRequestView>(`/reopen-requests/cases/${caseId}`, input), onSuccess: () => inv(caseId) });
}
export function useDecideReopenRequest(caseId: string) {
  const inv = useInvalidateReopen();
  return useMutation({ mutationFn: ({ id, ...input }: DecideReopenRequestInput & { id: string }) => apiPost<ReopenRequestView>(`/reopen-requests/${id}/decide`, input), onSuccess: () => inv(caseId) });
}
export function useCancelReopenRequest(caseId: string) {
  const inv = useInvalidateReopen();
  return useMutation({ mutationFn: ({ id, reason }: { id: string; reason: string }) => apiPost<ReopenRequestView>(`/reopen-requests/${id}/cancel`, { reason }), onSuccess: () => inv(caseId) });
}
